import DOMPurify from "dompurify";
import getUiString from "helpers/getUiString";
import { Marked } from "marked";
import React, { useMemo } from "react";

const marked = new Marked({ breaks: true });

// markdown only links out to our docs, and readmin is a single page app worth keeping open
DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName !== "A") return;

  node.setAttribute("target", "_blank");
  node.setAttribute("rel", "noopener noreferrer");
});

const DOCS_ARTICLE_URL = /^https:\/\/docs\.gloryleague\.basketball\/article\/([\w-]+)/;

// our docs are a help scout site, so the beacon can show these in place. Its ids are not the ones in
// the public url, they come from the article's editor url in help scout.
const BEACON_ARTICLE_IDS = {
  "109-advertising-asset-requirements": "69c3075a8f5fc0c1a8f6c433",
};

// beacon stacks a new view every time it is given an article, and it has no event for the article
// being dismissed inside the panel, so all we can do is drop the impatient repeat clicks
const BEACON_ARTICLE_REPEAT_MS = 2000;
const beaconArticleOpenedAt = {};

function openInBeacon(event) {
  // leave the modified clicks alone, they are how you deliberately open a link in a tab
  if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

  const link = event.target.closest("a");
  const articleId = BEACON_ARTICLE_IDS[link?.href.match(DOCS_ARTICLE_URL)?.[1]];
  if (!articleId || !window.Beacon) return;

  event.preventDefault();

  if (Date.now() - (beaconArticleOpenedAt[articleId] || 0) < BEACON_ARTICLE_REPEAT_MS) return;
  beaconArticleOpenedAt[articleId] = Date.now();

  // no type, so the article opens inside the beacon panel itself. This opens the beacon too if it is closed.
  window.Beacon("article", articleId);
}

export default function Markdown({ uiStringKey, source = uiStringKey && getUiString(uiStringKey) }) {
  const html = useMemo(() => DOMPurify.sanitize(marked.parse(source || "")), [source]);

  return <span onClick={openInBeacon} dangerouslySetInnerHTML={{ __html: html }} />;
}
